export const companySwitcherDropdown = {
  "en-US": {
    showing_companies_count_one: "Showing {{count}} company",
    showing_companies_count_other: "Showing {{count}} companies",
    invited_label: "Invited",
    selected_label: "Selected",
    no_results_found: "No results found",
    create_new_company_button: "Create New Company",
  },
};

export default companySwitcherDropdown;
